export * from './commonService'



// WEBPACK FOOTER //
// ./src/alelo-logic/services/index.js